import { render, staticRenderFns } from "./DialogRazao.vue?vue&type=template&id=ff560c7c"
import script from "./DialogRazao.vue?vue&type=script&lang=js"
export * from "./DialogRazao.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports